import { defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, action, entityActionSet, networkAction } from './utils';

export const
    markets = {
        ...entityActionSet(defaults.Market, {
            loadAll: networkAction('LOAD_ALL_MARKETS', getAPIMethod('Market', 'loadAll')),
            add: networkAction('ADD_MARKET', getAPIMethod('Market', 'add')),
            edit: networkAction('EDIT_MARKET', getAPIMethod('Market', 'edit')),
            delete: networkAction('DELETE_MARKET', getAPIMethod('Market', 'delete'))
        })
    },

    marketFreeNodes = {
        ...entityActionSet(defaults.MarketFreeNode, {
            loadAll: networkAction('LOAD_ALL_MARKET_FREE_NODES', getAPIMethod('MarketFreeNode', 'loadAll')),
            add: networkAction('ADD_MARKET_FREE_NODE', getAPIMethod('MarketFreeNode', 'add')),
            edit: networkAction('EDIT_MARKET_FREE_NODE', getAPIMethod('MarketFreeNode', 'edit')),
            delete: networkAction('DELETE_MARKET_FREE_NODE', getAPIMethod('MarketFreeNode', 'delete'))
        })
    },

    setMarketMapExpandedNodes = (expandedNodes: {
        defaultNodeIDs: number[],
        marketIDs: number[],
        marketCategoryIDs: number[],
        marketTrendTypeIDs: number[],
        trendCategoryIDs: number[],
        marketFreeNodeIDs: number[]
    }) => action('SET_MARKET_MAP_EXPANDED_NODES', { expandedNodes });

export type MarketAction = ExtractAction<
    | typeof markets
    | typeof marketFreeNodes
    | typeof setMarketMapExpandedNodes
>;